
import { v4 as uuid } from 'uuid'

export class TimeEntry {
  uuid: string
  id: number  
  user_id: number
  store_id: number
  project_type_id: number
  project_description: string
  date_worked: string
  is_current_pay_period: boolean
  start_time: string
  end_time: string        
  is_pending_save: boolean
  is_pending_delete: boolean
  non_billable_hours: number
  
  constructor() { 
  }

  public async setViewModelFields()
  {
    if (!this.id) {
      this.id = 0
    }
    if (!this.uuid) {
      this.uuid = uuid();
    }
    if (this.is_pending_save === undefined) {
      this.is_pending_save = false
    }
    if (this.is_pending_delete === undefined) {
      this.is_pending_delete = false
    }
  }

  static buildOne(obj: any): TimeEntry {
    let target: TimeEntry = Object.assign(new TimeEntry(), obj)  
    target.setViewModelFields()
    return target
  }

  static buildMany(objs: any[]): TimeEntry[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(TimeEntry.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

